import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon } from 'lucide-react';
export function ContactSection() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3110">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3111">
        <div className="mb-12" data-id="element-3112">
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-3113">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" style={{
            backgroundColor: 'rgba(200,168,75,0.15)'
          }} data-id="element-3114">
              <MailIcon size={24} style={{
              color: '#c8a84b'
            }} data-id="element-3115" />
            </div>
            <h2 className="text-2xl font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-3116">
              Questions?
            </h2>
            <p className="text-base text-gray-600 mb-4" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-3117">
              For questions or more information about the Refuse To Be A
              Victim® seminar, please contact us:
            </p>
            <Link to="/ContactUs.html" className="inline-flex items-center gap-2 text-lg font-semibold transition-colors hover:underline" style={{
            color: '#1e3d2f',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-3118">
              Contact the Club
            </Link>
          </div>
        </div>
      </div>
    </div>;
}